module.exports = __webpack_public_path__ + "img/mission-diversity-board-face-2.jpg?ec1b70a17429c0b461dccaca43c90cb8";